module.exports = __webpack_public_path__ + "img/icon_bath.dbe69bc3.svg";